module.exports = __webpack_public_path__ + "static/media/acura-logo-dark.579c6601.svg";